module.exports = __webpack_public_path__ + "static/media/datasheet_entData_row2_picture.46001048.png";